module.exports = __webpack_public_path__ + "img/chagora_no.c24b8fbc.png";